// extracted by mini-css-extract-plugin
export default {"badge-wrap":"Capsules_badge-wrap__o6bb6","right":"Capsules_right__bYXM4","tooltip-icon":"Capsules_tooltip-icon__6wYio","badge":"Capsules_badge__Uts8F","icon":"Capsules_icon__s0xGb"};